import LwModalComponent from "./modal";

export const LwModalInstall = Vue => {
  const Constructor = Vue.extend(LwModalComponent);
  Vue.component("lw-modal", Constructor);
};
